module.exports = __webpack_public_path__ + "img/factory-1.41cda2a3.jpg";